// @flow

export const BASE_URL = '/app/settings';
export const SETTINGS_V2_SWITCH = 'settings_v2';
